import { MapPin, Phone, Mail, Globe, Building2 } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const formatPhone = (p) => (p && /^\d{8}$/.test(p) ? `${p.slice(0, 3)} ${p.slice(3, 5)} ${p.slice(5)}` : p || "");

/**
 * Offentlig kontaktinfo for arrangøren (org.nr, adresse, telefon, e-post, nettside).
 * Vipps MobilePay krever at dette er synlig der billettene selges – vises derfor på arrangør- og arrangementssiden.
 * Rendrer ingenting utover org.nr hvis arrangøren ikke har lagt inn noe.
 */
export const OrganizerContactBlock = ({ name, orgNumber, contact, compact = false, className = "" }) => {
  const { t } = useLang();
  const c = contact || {};
  const addressLine = [c.address, [c.postal_code, c.city].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  const website = c.website ? c.website.replace(/^https?:\/\//, "").replace(/\/$/, "") : "";
  const hasAny = !!(addressLine || c.phone || c.email || c.website || orgNumber);
  if (!hasAny) return null;
  const rows = [
    orgNumber && { key: "orgnr", icon: Building2, text: t("Org.nr {n}", { n: orgNumber }) },
    addressLine && { key: "address", icon: MapPin, text: addressLine },
    c.phone && { key: "phone", icon: Phone, text: formatPhone(c.phone), href: `tel:+47${c.phone}` },
    c.email && { key: "email", icon: Mail, text: c.email, href: `mailto:${c.email}` },
    c.website && { key: "website", icon: Globe, text: website, href: c.website, external: true },
  ].filter(Boolean);
  return (
    <div className={`rounded-xl border border-border bg-card ${compact ? "p-4" : "p-5"} ${className}`} data-testid="organizer-contact-block">
      <p className={`font-medium ${compact ? "text-sm" : ""} mb-2`}>{name ? t("Kontakt {name}", { name }) : t("Kontakt arrangøren")}</p>
      <ul className={`space-y-1.5 ${compact ? "text-sm" : "text-sm sm:text-[15px]"}`}>
        {rows.map((r) => {
          const Icon = r.icon;
          const inner = (
            <>
              <Icon className="w-4 h-4 shrink-0 text-muted-foreground mt-0.5" />
              <span className="break-words min-w-0">{r.text}</span>
            </>
          );
          return (
            <li key={r.key} className="flex items-start gap-2" data-testid={`organizer-contact-${r.key}`}>
              {r.href ? (
                <a href={r.href} target={r.external ? "_blank" : undefined} rel={r.external ? "noreferrer" : undefined} className="flex items-start gap-2 underline-offset-4 hover:underline text-foreground transition-colors duration-150">
                  {inner}
                </a>
              ) : (
                inner
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
